module.exports = __webpack_public_path__ + "static/img/086.1f232ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/086.png
// module id = ZuM1
// module chunks = 0